(function () {
  function initDirectory(root) {
    if (!root || root.dataset.mbbDirectoryInitialized === 'true') return;
    root.dataset.mbbDirectoryInitialized = 'true';

    var searchInput = root.querySelector('[data-mbb-directory-search]');
    var pillsWrap = root.querySelector('[data-mbb-family-pills]');
    var familySections = Array.prototype.slice.call(root.querySelectorAll('[data-mbb-family-section]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mbb-theme-card]'));
    var visibleThemeCount = root.querySelector('[data-mbb-visible-theme-count]');
    var visibleFamilyCount = root.querySelector('[data-mbb-visible-family-count]');
    var activeFilter = 'all';

    function uniqueFamilies() {
      var seen = {};
      var families = [];
      familySections.forEach(function (section) {
        var key = section.getAttribute('data-family-key') || '';
        var label = section.getAttribute('data-family-label') || key;
        if (!key || seen[key]) return;
        seen[key] = true;
        families.push({ key: key, label: label });
      });
      return families;
    }

    function renderButtons() {
      if (!pillsWrap) return;
      var allLabel = root.getAttribute('data-all-label') || 'All families';
      var html = '<button class="mbb-browse-filter-pill is-active" type="button" data-filter="all">' + allLabel + '</button>';
      uniqueFamilies().forEach(function (family) {
        html += '<button class="mbb-browse-filter-pill" type="button" data-filter="' + family.key + '">' + family.label + '</button>';
      });
      pillsWrap.innerHTML = html;
    }

    function applyFilters() {
      var query = (searchInput && searchInput.value ? searchInput.value : '').trim().toLowerCase();
      var visibleCards = 0;
      var visibleFamilies = 0;

      cards.forEach(function (card) {
        var family = card.getAttribute('data-family') || '';
        var haystack = ((card.getAttribute('data-search') || '') + ' ' + card.textContent).toLowerCase();
        var matchesFilter = activeFilter === 'all' || family === activeFilter;
        var matchesSearch = !query || haystack.indexOf(query) !== -1;
        var show = matchesFilter && matchesSearch;
        card.classList.toggle('is-hidden', !show);
        if (show) visibleCards += 1;
      });

      familySections.forEach(function (section) {
        var visibleInSection = section.querySelectorAll('[data-mbb-theme-card]:not(.is-hidden)').length;
        var hide = visibleInSection === 0;
        section.classList.toggle('is-hidden', hide);
        if (!hide) visibleFamilies += 1;
      });

      if (visibleThemeCount) visibleThemeCount.textContent = String(visibleCards);
      if (visibleFamilyCount) visibleFamilyCount.textContent = String(visibleFamilies);
    }

    renderButtons();
    applyFilters();

    if (pillsWrap) {
      pillsWrap.addEventListener('click', function (event) {
        var button = event.target.closest('[data-filter]');
        if (!button) return;
        activeFilter = button.getAttribute('data-filter') || 'all';
        Array.prototype.slice.call(pillsWrap.querySelectorAll('[data-filter]')).forEach(function (pill) {
          pill.classList.toggle('is-active', pill === button);
        });
        applyFilters();
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', applyFilters);
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-mbb-directory-root]');
    Array.prototype.forEach.call(roots, initDirectory);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });
})();